import { FornecedorAlteracao } from "../../../components/fornecedor/alteracao/Alteracao"

export const AlteracaoFornecedorPage = () => {
    return (
        <div style={{
            margin: "auto"
        }}>
            <FornecedorAlteracao />
        </div>
    )
}